import { useState } from 'react';
import { KeyRound, Loader2, Orbit } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { useAuth } from '@/contexts/AuthContext';
import { useToast } from '@/hooks/use-toast';

export function AuthPage() {
  const { loginWithSaId } = useAuth();
  const { toast } = useToast();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSaIdLogin = async () => {
    setIsSubmitting(true);
    try {
      const returnTo = window.location.pathname.startsWith('/auth') ? '/week' : window.location.pathname || '/week';
      await loginWithSaId(returnTo);
    } catch (error) {
      toast({
        title: 'Could not open SaID',
        description: error instanceof Error ? error.message : 'Check your connection and try again.',
        variant: 'destructive',
      });
      setIsSubmitting(false);
    }
  };

  return (
    <div className="flex min-h-dvh items-center justify-center bg-background p-6">
      <div className="w-full max-w-sm">
        <div className="mb-6 flex items-center justify-center gap-2">
          <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary text-primary-foreground shadow-[0_0_34px_hsl(var(--primary)/0.34)]">
            <Orbit className="h-6 w-6" />
          </span>
          <div>
            <h1 className="text-2xl font-bold leading-tight">Fluxiplanner</h1>
            <p className="text-xs text-muted-foreground">One account, many workspaces.</p>
          </div>
        </div>

        <Card>
          <CardHeader>
            <CardTitle>Sign in to Fluxiplanner</CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            <p className="text-sm text-muted-foreground">
              Use SaID to open your planner, teams, and settings. Existing Mail-linked accounts are matched after SaID verifies your email.
            </p>
            <Button type="button" className="w-full" disabled={isSubmitting} onClick={handleSaIdLogin}>
              {isSubmitting ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <KeyRound className="mr-2 h-4 w-4" />}
              {isSubmitting ? 'Opening SaID...' : 'Continue with SaID'}
            </Button>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
